'use strict';

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _regeneratorRuntime = require('babel-runtime/regenerator')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _graphql = require('graphql');

var _forks__FormatRequestErrors = require('./__forks__/formatRequestErrors');

var _forks__FormatRequestErrors2 = _interopRequireDefault(_forks__FormatRequestErrors);

var NetworkLayer = (function () {
  function NetworkLayer(_ref) {
    var schema = _ref.schema;
    var rootValue = _ref.rootValue;
    var contextValue = _ref.contextValue;
    var onError = _ref.onError;

    _classCallCheck(this, NetworkLayer);

    this._schema = schema;
    this._rootValue = rootValue;
    this._contextValue = contextValue;
    this._onError = onError;
  }

  NetworkLayer.prototype.sendMutation = function sendMutation(mutationRequest) {
    if (mutationRequest.getFiles()) {
      throw new Error('uploading files not supported');
    }

    return this._executeRequest('mutation', mutationRequest);
  };

  NetworkLayer.prototype.sendQueries = function sendQueries(queryRequests) {
    var _this = this;

    return _Promise.all(queryRequests.map(function (queryRequest) {
      return _this._executeRequest('query', queryRequest);
    }));
  };

  NetworkLayer.prototype._executeRequest = function _executeRequest(requestType, request) {
    var _ref2, data, errors;

    return _regeneratorRuntime.async(function _executeRequest$(context$2$0) {
      while (1) switch (context$2$0.prev = context$2$0.next) {
        case 0:
          context$2$0.next = 2;
          return _regeneratorRuntime.awrap(_graphql.graphql(this._schema, request.getQueryString(), this._rootValue, this._contextValue, request.getVariables()));

        case 2:
          _ref2 = context$2$0.sent;
          data = _ref2.data;
          errors = _ref2.errors;

          if (!errors) {
            context$2$0.next = 9;
            break;
          }

          request.reject(new Error('Failed to execute ' + requestType + ' `' + request.getDebugName() + '` for ' + ('the following reasons:\n\n' + _forks__FormatRequestErrors2['default'](request, errors))));
          if (this._onError) {
            this._onError(errors, request);
          }
          return context$2$0.abrupt('return');

        case 9:

          request.resolve({ response: data });

        case 10:
        case 'end':
          return context$2$0.stop();
      }
    }, null, this);
  };

  NetworkLayer.prototype.supports = function supports() {
    return false;
  };

  return NetworkLayer;
})();

exports['default'] = NetworkLayer;
module.exports = exports['default'];